<template>
  <div class="ppp-suitability-tab">
    <div class="tab-header">
      <h2>PPP Suitability</h2>
      <p class="tab-description">
        Public-private partnership viability analysis
      </p>
    </div>

    <form @submit.prevent="validateAndSubmit" class="project-form">
      
      <!-- Section A: Qualitative assessment of Value for Money -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section A: Qualitative assessment of Value for Money</h3>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1. Do the project size and contract duration have the potential to maximize private sector efficiency?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q1" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q1" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q1" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q1" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q1" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionA_q1_comments">Comments</label>
            <textarea 
              id="sectionA_q1_comments"
              v-model="formData.sectionA_q1_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2. Does the PPP adequately integrate responsibility for design, build and finance with O&M risks under one party that enables the private sector to derive efficiency gains from better management (than what the public sector could have achieved) of the whole-of-life-cycle costs of the project?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q2" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q2" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q2" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q2" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q2" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionA_q2_comments">Comments</label>
            <textarea 
              id="sectionA_q2_comments"
              v-model="formData.sectionA_q2_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3. Is there potential for the private sector to operate and manage the project more efficiently than the public sector to decrease the project's whole-of-life-costs?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q3" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q3" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q3" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q3" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q3" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionA_q3_comments">Comments</label>
            <textarea 
              id="sectionA_q3_comments"
              v-model="formData.sectionA_q3_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">4. Is there potential for a private operator to generate higher revenues than the public sector would have through better utilization of the project assets?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q4" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q4" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q4" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q4" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q4" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionA_q4_comments">Comments</label>
            <textarea 
              id="sectionA_q4_comments"
              v-model="formData.sectionA_q4_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

      <!-- Section B: Quantitative assessment of Value for Money -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section B: Quantitative assessment of Value for Money</h3>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1. Are the modeling assumptions backed by historical or empirical data?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q1" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q1" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q1" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q1" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q1" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionB_q1_comments">Comments</label>
            <textarea 
              id="sectionB_q1_comments"
              v-model="formData.sectionB_q1_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2. Is the value for money (VFM) for the project greater than the threshold VFM requirement?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q2" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q2" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q2" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q2" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q2" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionB_q2_comments">Comments</label>
            <textarea 
              id="sectionB_q2_comments"
              v-model="formData.sectionB_q2_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3. Will the VFM for the project remain greater than the threshold rate in the stress (or low) case scenario?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q3" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q3" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q3" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q3" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q3" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionB_q3_comments">Comments</label>
            <textarea 
              id="sectionB_q3_comments"
              v-model="formData.sectionB_q3_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

      <!-- Section C: Market appetite -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section C: Market appetite</h3>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1. Is there a favorable response expected from the private sector towards the project? For example, as gauged by the contracting agency through preliminary market consultations or similar investor interactions.</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q1" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q1" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q1" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q1" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q1" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionC_q1_comments">Comments</label>
            <textarea 
              id="sectionC_q1_comments"
              v-model="formData.sectionC_q1_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2. Have similar PPP projects been successfully implemented in the past in the country or region?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q2" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q2" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q2" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q2" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q2" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionC_q2_comments">Comments</label>
            <textarea 
              id="sectionC_q2_comments"
              v-model="formData.sectionC_q2_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3. Will debt financing be available for the project with a relatively long tenure (more than 7 years) and at a reasonable cost?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q3" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q3" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q3" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q3" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q3" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionC_q3_comments">Comments</label>
            <textarea 
              id="sectionC_q3_comments"
              v-model="formData.sectionC_q3_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">4. Is the project eligible for government funding support?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q4" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q4" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q4" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q4" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q4" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionC_q4_comments">Comments</label>
            <textarea 
              id="sectionC_q4_comments"
              v-model="formData.sectionC_q4_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">5. Is the project eligible for funding/ guarantees from multilateral/donor agencies?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q5" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q5" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q5" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q5" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q5" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionC_q5_comments">Comments</label>
            <textarea 
              id="sectionC_q5_comments"
              v-model="formData.sectionC_q5_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

    </form>
  </div>
</template>

<script>
export default {
  name: 'PPPSuitabilityTab',
  props: {
    projectData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        // Section A: Qualitative assessment of Value for Money
        sectionA_q1: '',
        sectionA_q1_comments: '',
        sectionA_q2: '',
        sectionA_q2_comments: '',
        sectionA_q3: '',
        sectionA_q3_comments: '',
        sectionA_q4: '',
        sectionA_q4_comments: '',
        
        // Section B: Quantitative assessment of Value for Money
        sectionB_q1: '',
        sectionB_q1_comments: '',
        sectionB_q2: '',
        sectionB_q2_comments: '',
        sectionB_q3: '',
        sectionB_q3_comments: '',
        
        // Section C: Market appetite
        sectionC_q1: '',
        sectionC_q1_comments: '',
        sectionC_q2: '',
        sectionC_q2_comments: '',
        sectionC_q3: '',
        sectionC_q3_comments: '',
        sectionC_q4: '',
        sectionC_q4_comments: '',
        sectionC_q5: '',
        sectionC_q5_comments: ''
      },
      errors: {},
      showValidation: false
    }
  },
  computed: {
    isValid() {
      return this.validateForm().isValid
    }
  },
  watch: {
    projectData: {
      handler(newData) {
        if (newData && Object.keys(newData).length > 0) {
          this.formData = { ...this.formData, ...newData }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    updateData() {
      this.$emit('update', this.formData)
      this.validateForm()
    },
    validateForm() {
      this.errors = {}
      let isValid = true

      this.showValidation = true
      this.$emit('validate', isValid)
      
      return { isValid, errors: this.errors }
    },
    validateAndSubmit() {
      this.validateForm()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.validateForm()
    })
  }
}
</script>

<style scoped>
.ppp-suitability-tab {
  max-width: 1000px;
  margin: 0 auto;
}

.tab-header {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #e9ecef;
}

.tab-header h2 {
  font-size: 2rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.tab-description {
  color: #666;
  font-size: 1.1rem;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
}

.form-section {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  border-left: 4px solid #00338d;
}

.section-header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.section-header h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
  display: block;
}

.form-group textarea {
  padding: 0.75rem;
  border: 2px solid #e0e6ed;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s, box-shadow 0.3s;
  background: white;
  resize: vertical;
  min-height: 100px;
  font-family: inherit;
}

.form-group textarea:focus {
  outline: none;
  border-color: #00338d;
  box-shadow: 0 0 0 3px rgba(0, 51, 141, 0.1);
}

.checkbox-label {
  display: block !important;
}

.checkbox-text {
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
  display: block;
}

.radio-group {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 0.75rem;
  margin-top: 0.75rem;
  align-items: stretch;
}

.radio-option {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 500;
  padding: 0.75rem 1rem;
  min-height: 40px;
  position: relative;
  transition: all 0.2s ease;
  border-radius: 8px;
  border: 2px solid #d1d5db;
  background: #ffffff;
  color: #374151;
  text-align: center;
}

.radio-option input[type="radio"] {
  display: none;
}

.radio-option:has(input[type="radio"]:checked) {
  background: #00338d;
  border-color: #00338d;
  color: white;
  font-weight: 600;
  box-shadow: 0 0 0 2px rgba(0, 51, 141, 0.2);
}

.radio-option:hover {
  background-color: #e8f0fe;
  border-color: #00338d;
  color: #00338d;
}

.radio-option:hover:has(input[type="radio"]:checked) {
  background: #002966;
  border-color: #002966;
  color: white;
}

.radio-option:has(input[type="radio"]:focus) {
  border-color: #00338d;
  box-shadow: 0 0 0 3px rgba(0, 51, 141, 0.1);
  outline: none;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .radio-group {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    margin-top: 0.5rem;
  }
  
  .radio-option {
    padding: 0.75rem 0.75rem;
    min-height: 44px;
    font-size: 0.95rem;
  }
  
  .form-section {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .radio-group {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
  
  .radio-option {
    padding: 1rem 0.75rem;
    min-height: 48px;
    font-size: 0.9rem;
  }
}
</style>